import { Smartphone, Tablet, Laptop, Cpu, Droplets, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { SERVICES } from "@/lib/site";
import { scrollToSection } from "@/lib/scroll";

const ICONS = {
  smartphones: Smartphone,
  tablettes: Tablet,
  ordinateurs: Laptop,
  "micro-soudure": Cpu,
  desoxydation: Droplets,
};

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-32">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Nos services"
          title={<>Un atelier complet, <span className="text-neon">du verre à la carte mère</span></>}
          sub="Du remplacement d'écran à la micro-soudure la plus fine, tout est réalisé en atelier à Saint-Pierre-en-Faucigny."
        />

        <div className="mt-14 grid gap-4 md:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <Reveal key={s.id} delay={i * 0.07} className={s.span}>
                <div className="group relative flex h-full min-h-[220px] flex-col justify-end overflow-hidden rounded-2xl border border-line bg-ink p-6 transition-colors duration-300 hover:border-neon/40">
                  {s.img && (
                    <>
                      <img
                        src={s.img}
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 h-full w-full object-cover opacity-45 transition-opacity duration-500 group-hover:opacity-60"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-night via-night/70 to-night/10" />
                    </>
                  )}
                  <div className="relative">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-neon/25 bg-neon/10 text-neon">
                      <Icon size={20} />
                    </span>
                    <h3 className="mt-4 font-display text-2xl font-bold uppercase tracking-tight text-white">{s.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                    {s.tags && (
                      <div className="mt-4 flex flex-wrap gap-2">
                        {s.tags.map((t) => (
                          <span key={t} className="rounded-full border border-line bg-night/60 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-400">
                            {t}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </Reveal>
            );
          })}

          <Reveal delay={0.35} className="md:col-span-2">
            <button
              data-testid="services-devis-card"
              onClick={() => scrollToSection("#devis")}
              className="group flex h-full min-h-[220px] w-full flex-col justify-between rounded-2xl border border-neon/40 bg-gradient-to-br from-neon/15 to-neonblue/10 p-6 text-left transition-transform duration-300 hover:scale-[1.01]"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-neon text-night chip-glow">
                <ArrowRight size={20} />
              </span>
              <div>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
                  Un doute sur votre panne ?
                </h3>
                <p className="mt-2 text-sm text-slate-400">
                  Décrivez-nous le problème : le diagnostic est gratuit et le devis sans engagement.
                </p>
              </div>
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <p className="mx-auto mt-10 max-w-4xl text-center text-sm leading-relaxed text-slate-400">
            <strong className="font-semibold text-white">Marques et appareils pris en charge :</strong> Apple (iPhone, iPad, MacBook), Samsung
            (Galaxy S, A, Z, Tab), Google Pixel, Xiaomi, Redmi, POCO, Huawei, Honor, OnePlus, Oppo, Realme, Motorola, Nokia, Sony, Wiko, Asus,
            Acer, Lenovo, HP, Dell et MSI. Un autre appareil ou une panne qui ne figure pas dans la liste ? Demandez-nous : on vous répond vite,
            avec ou sans rendez-vous.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
